import Button from "@mui/material/Button";

export default function TheButton({
  children,
  variant = "contained",
  ...props
}) {
  return (
    <Button
      variant={variant}
      sx={{
        color:
          variant === "contained"
            ? "var(--background-color)"
            : "var(--text-color)",

        background:
          variant === "contained"
            ? "linear-gradient(-40deg, var(--accent-color) 0%, var(--accent-color2) 100%)"
            : "transparent",

        border:
          variant === "outlined" ? "1px solid var(--accent-color2)" : "none",

        fontSize: " clamp(11px, 3vw, 15px)",

        padding: "clamp(0.2rem, 2vw, .5rem) clamp(0.3rem, 2.5vw, .7rem)",

        textTransform: "none",

        ":hover": {
          opacity: 0.8,
        },
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
